/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function myFunction() {}
var _default = myFunction.toString() != 'function myFunction(abc) { /* this is a simple comment */ }';
exports.default = _default;